import { render, staticRenderFns } from "./UserPortrait.vue?vue&type=template&id=95f2cbda&scoped=true&"
import script from "./UserPortrait.vue?vue&type=script&lang=js&"
export * from "./UserPortrait.vue?vue&type=script&lang=js&"
import style0 from "./UserPortrait.vue?vue&type=style&index=0&id=95f2cbda&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "95f2cbda",
  null
  
)

export default component.exports